import { useCallback, useState } from 'react';

interface UseListNameEditorProps {
  onNameChange?: () => void;
}

export const useListNameEditor = ({ onNameChange }: UseListNameEditorProps) => {
  const [listName, setListName] = useState('');
  const [isRenameActive, setIsRenameActive] = useState(false);

  const onUpdateName = useCallback(
    (name: string) => {
      const hasChanged = name !== listName;
      setListName(name);

      if (hasChanged) {
        onNameChange?.();
      }
    },
    [listName, onNameChange]
  );

  const resetName = useCallback(() => {
    setListName('');
  }, []);

  return {
    listName,
    isRenameActive,
    setIsRenameActive,
    onUpdateName,
    resetName,
  };
};
